import { render, staticRenderFns } from "./BackofficeStatuses.vue?vue&type=template&id=4a553032&scoped=true"
import script from "./BackofficeStatuses.vue?vue&type=script&lang=js"
export * from "./BackofficeStatuses.vue?vue&type=script&lang=js"
import style0 from "./BackofficeStatuses.vue?vue&type=style&index=0&id=4a553032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a553032",
  null
  
)

export default component.exports